export const rezyParkStyles = {
	header: {
		backgroundColor: '#000053',
		color: '#ffffff',
	},
	sidebar: {
		backgroundColor: '#000053',
		color: '#ffffff',
	},

	button: {
		backgroundColor: '#ff5604',
		fontWeight: 600,
		color: '#ffffff',
		':hover': {
			color: '#ffffff',
			backgroundColor: '#ff5604',
		},
	},
	title: {
		color: '#ffffff',
	},
	outlinedButton: {
		border: '4px solid #ffffff',
		':hover': {
			border: '4px solid #000053',
		},
	},
	text: {
		color: '#000053',
	},
	table: {
		headerBackgroundColor: '#000053',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'RezyPark Platform',
	},
	logo: {
		small: {
			src: '/rezyPark/rezy-park-logo-white.svg',
			height: 40,
			width: 40,
		},
		large: {
			src: '/rezyPark/rezy-park-logo-white.svg',
			height: 40,
			width: 135,
		},
	},
	favicon: {
		src: '/rezyPark/rezy-park-logo-white.svg',
	},
	socials: {},
	siteUrl: 'https://www.rezypark.com/',
	orgName: 'RezyPark',
};
